// Front Pages
import Home from "../pages/front/Home";

// Authentication Pages
import AdminLogin from "../pages/admin/signIn/AdminLogin";
import AdminForgotPassword from "../pages/auth/ForgotPassword";

// Admin Pages
import Testimonials from "../pages/admin/Testimonials";
import TestimonialDetails from "../components/sections/admin/testimonials/TestimonialDetails.js";
import Category from "../pages/admin/Category";
import Dashboard from "../pages/admin/Dashboard.js";
import AdminList from "../pages/admin/admins/AdminList";
import UserList from "../pages/admin/users/UserList.js";
import UserDetailsPage from "../pages/admin/users/UserDetailsPage.js";
import Faq from "../pages/admin/faq/Faq.js";
import Hiw from "../pages/admin/hiw/Hiw.js";
import SiteSettings from "../pages/admin/Sitesetting";
import EmailTemplate from "../pages/admin/EmailTemplate";
import ProfileComponent from "../components/profile/Profile.js";
import Banners from "../pages/admin/Banners";
import ManageBanner from "../components/sections/admin/banner/ManageBanner";
import Plans from "../pages/admin/plans/Plans.js";
import Subscription from "../pages/admin/subscription/Subscription.js";
import Pages from "../pages/admin/pages/Pages.js";
import PagesSections from "../pages/admin/sections/PagesSections.js";
import FooterSections from "../pages/admin/sections/FooterSections.js";
import Transaction from "../pages/admin/transaction/Transaction.js";
import Order from "../pages/admin/order/Orders.js";
import CollectionTemplate from "../pages/admin/CollectionTemplate/CollectionTemplate.js";
import UserCollection from "../pages/admin/UserCollection/UserCollection.js";
import UserCollectioncovercontent from "../pages/admin/UserCollection/UserCollectioncovercontent.js";
import UserCollectionDetails from "../pages/admin/UserCollection/UserCollectionDetails.js";
// User Pages
import UserProfile from "../pages/front/account/Profile.js";
import UserOrders from "../pages/front/account/Orders.js";
import UserOrderDetails from "../pages/front/account/OrderDetails.js";
import UserSubscriptions from "../pages/front/account/Subscriptions.js";
import UserAddress from "../pages/front/account/ManageAddress.js";
import UserTransactions from "../pages/front/account/Transactions.js";
import UserPlaceOrder from "../pages/front/account/PlaceOrder.js";
import UserMedia from "../pages/front/account/UserMedia.js";
import Cart from "../pages/front/account/cart/Cart.js";
import ChoosePlan from "../pages/front/account/ChoosePlan.js";
import BookCheckout from "../pages/front/account/BookCheckout.js";
import ThankYou from "../pages/front/account/ThankYou.js";
import PaymentPage from "../pages/front/account/PaymentPage.js";
import ManagePagesSection from "../components/sections/admin/sections/ManagePagesSection.js";
import ManageFooterPagesSection from "../components/sections/admin/sections/ManageFooterPagesSection.js";
import HowItWorks from "../pages/front/HowItWorks.js";
import Signin from "../pages/front/authentication/Signin.js";
import SignUp from "../pages/front/authentication/SignUp.js";
import ForgotPassword from "../pages/front/authentication/ForgotPassword.js";
import OtpVerification from "../pages/front/authentication/OtpVerification.js";
import ResetPassword from "../pages/front/authentication/ResetPassword.js";
import BookCreation from "../pages/front/account/BookCreation.js";
import UserLandingPage from "../pages/front/account/UserLandingPage.js";
import CoverEditorScreen from "../components/sections/front/User/CoverEditorScreen.js";
import ReviewBookContent from "../components/sections/front/User/ReviewBookContent.js";
import HomeTAC from "../components/sections/front/sections/HomeTAC.js";
import HomePAP from "../components/sections/front/sections/HomePAP.js";
import ShopifyCallback from "../pages/front/authentication/ShopifyCallback.js";

export const frontRoutes = (data) => {
  return [
    {
      path: "/",
      title: "Home",
      component: Home,
      routeType: false,
      layout: "front",
    },
    {
      path: "/how-it-works",
      title: "How It Works",
      component: HowItWorks,
      routeType: false,
      layout: "front",
    },
    {
      path: "/terms-and-conditions",
      title: "Terms And Conditions",
      component: HomeTAC,
      routeType: false,
      layout: "front",
    },
    {
      path: "/privacy-policy",
      title: "Privacy And Policies",
      component: HomePAP,
      routeType: false,
      layout: "front",
    },
  ];
};

export const authRoutes = (data) => [
  {
    path: "/signin",
    title: "Signin",
    component: Signin,
    routeType: false,
    layout: "front",
  },
  {
    path: "/signup",
    title: "Signup",
    component: SignUp,
    routeType: false,
    layout: "front",
  },
  {
    path: "/otp-verification",
    title: "OTP Verification",
    component: OtpVerification,
    routeType: false,
    layout: "front",
  },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: false,
    layout: "front",
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    component: ForgotPassword,
    routeType: false,
    layout: "front",
  },
  {
    path: "/auth/callback",
    title: "Verifying Authentication...",
    component: ShopifyCallback,
    routeType: false,
    layout: "front",
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];

export const adminRoutes = (data) => [
  {
    path: "/user/profile",
    title: "Profile",
    layout: "admin",
    routeType: "ADMIN",
    component: ProfileComponent,
  },
  {
    path: "/admin",
    title: "dashboard",
    layout: "admin",
    routeType: "ADMIN",
    component: Dashboard,
  },
  {
    path: "/admin/dashboard",
    title: "dashboard",
    layout: "admin",
    routeType: "ADMIN",
    component: Dashboard,
  },
  {
    path: "/admin/testimonials",
    title: "testimonials",
    layout: "admin",
    routeType: "ADMIN",
    component: Testimonials,
  },
  {
    path: "/admin/testimonials/details/:id",
    title: "testimonials details",
    layout: "admin",
    routeType: "ADMIN",
    component: TestimonialDetails,
  },
  {
    path: "/admins",
    title: "Admin List",
    layout: "admin",
    routeType: "ADMIN",
    component: AdminList,
  },
  {
    path: "/admin/users",
    title: "User List",
    layout: "admin",
    routeType: "ADMIN",
    component: UserList,
  },
  {
    path: "/admin/users/details/:id",
    title: "User's details",
    layout: "admin",
    routeType: "ADMIN",
    component: UserDetailsPage,
  },
  {
    path: "/admin/collection-template",
    title: "Collection Templates",
    layout: "admin",
    routeType: "ADMIN",
    component: CollectionTemplate,
  },
  {
    path: "/admin/user-collections",
    title: "User's Collections",
    layout: "admin",
    routeType: "ADMIN",
    component: UserCollection,
  },
  {
    path: "/admin/user-collections/details/:id",
    title: "User's Collections Pages Details",
    layout: "admin",
    routeType: "ADMIN",
    component: UserCollectionDetails,
  },
  {
    path: "/admin/user-collections/cover-content/:id",
    title: "User's Collections cover content",
    layout: "admin",
    routeType: "ADMIN",
    component: UserCollectioncovercontent,
  },
  {
    path: "/admin/faq",
    title: "FAQ List",
    layout: "admin",
    routeType: "ADMIN",
    component: Faq,
  },
  {
    path: "/admin/how-it-works",
    title: "HIW List",
    layout: "admin",
    routeType: "ADMIN",
    component: Hiw,
  },
  {
    path: "/admin/site-settings",
    title: "settings",
    layout: "admin",
    routeType: "ADMIN",
    component: SiteSettings,
  },
  {
    path: "/admin/email-template",
    title: "Email Template",
    layout: "admin",
    routeType: "ADMIN",
    component: EmailTemplate,
  },
  {
    path: "/admin/:categoryType/categories",
    title: "categories",
    layout: "admin",
    routeType: "admin",
    component: Category,
  },
  {
    path: "/admin/pages",
    title: "sections",
    layout: "admin",
    routeType: "ADMIN",
    component: PagesSections,
  },
  {
    path: "/admin/footer-pages",
    title: "footer",
    layout: "admin",
    routeType: "ADMIN",
    component: FooterSections,
  },
  {
    path: "/admin/footerPages/manage",
    layout: "admin",
    routeType: "ADMIN",
    component: ManageFooterPagesSection,
  },
  {
    path: "/admin/pages/manage",
    layout: "admin",
    routeType: "ADMIN",
    component: ManagePagesSection,
  },
  {
    path: "/admin/banners",
    title: "banners",
    layout: "admin",
    routeType: "ADMIN",
    component: Banners,
  },
  {
    path: "/admin/banners/manage",
    layout: "admin",
    routeType: "ADMIN",
    component: ManageBanner,
  },
  {
    path: "/admin/plans",
    title: "plans",
    layout: "admin",
    routeType: "ADMIN",
    component: Plans,
  },
  {
    path: "/admin/subscription",
    title: "subscription",
    layout: "admin",
    routeType: "ADMIN",
    component: Subscription,
  },
  {
    path: "/admin/transaction",
    title: "Transaction",
    layout: "admin",
    routeType: "ADMIN",
    component: Transaction,
  },
  {
    path: "/admin/orders",
    title: "Orders",
    layout: "admin",
    routeType: "ADMIN",
    component: Order,
  },
];

export const userRoutes = (data) => [
  {
    path: "/create-book",
    title: "Book Creation",
    component: BookCreation,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/dashboard",
    title: "Dashboard",
    component: UserLandingPage,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/profile",
    title: "Profile",
    component: UserProfile,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/orders",
    title: "Orders",
    component: UserOrders,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/orders/:orderId",
    title: "Orders",
    component: UserOrderDetails,
    routeType: false,
    layout: "user",
  },
  {
    path: "/plan",
    title: "Plan",
    component: UserSubscriptions,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/address",
    title: "Manage Address",
    component: UserAddress,
    // routeType: false,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/transactions",
    title: "Transactions",
    component: UserTransactions,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/create",
    title: "Place Order",
    component: UserPlaceOrder,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/cover-image",
    title: "Cover Image",
    component: CoverEditorScreen,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/review",
    title: "Review Book",
    component: ReviewBookContent,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/choose-plan",
    title: "Choose Plan",
    component: ChoosePlan,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/checkout",
    title: "Checkout",
    component: BookCheckout,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/media",
    title: "Media",
    component: UserMedia,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/cart",
    title: "Cart",
    component: Cart,
    routeType: "USER",
    layout: "user",
  },
  {
    path: "/thank-you",
    title: "ThankYou",
    component: ThankYou,
    routeType: false,
    layout: "user",
  },
  {
    path: "/payment",
    title: "Payment",
    component: PaymentPage,
    routeType: "USER",
    layout: "user",
  }
];

export const routerData = (data) => {
  return [
    ...userRoutes(data),
    ...adminRoutes(data),
    ...authRoutes(data),
    ...frontRoutes(data),
  ];
};
